import './App.scss';
// import 'bootstrap/dist/css/bootstrap.css';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'bootstrap/dist/js/bootstrap.min.js';
// DataTables Core
import 'datatables.net/js/jquery.dataTables.min.js';
import 'datatables.net-responsive/js/dataTables.responsive.min.js';
// DataTables Bootstrap 4 theme plugin (automatically injects dom structure)
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';


import {graphTokenRequest,backendApiTokenRequest,createTokenRefreshManager} from './authConfig';
import {AccountInfo, InteractionType} from '@azure/msal-browser';
import {useMsal, useMsalAuthentication} from '@azure/msal-react';
import {useEffect, useState} from 'react';
import {fetchUser} from './services/msgraph';
import {AccountResponse} from './types/msAccount';
import Router from './Router';

(window as any).$ = $;
(window as any).jQuery = $;

function App() {
    // Remove these lines to disable sso authentication, meaning everyone (non-cx users) can access to the site
    /*--------------------------------------------------------------------------------------------------------*/
    const {error} = useMsalAuthentication(InteractionType.Redirect);

    const {instance, accounts} = useMsal();
    const [account, setAccount] = useState<AccountInfo | null>(null);
    const [accessToken, setAccessToken] = useState<string | null>(null);
    const [userData, setUserData] = useState<AccountResponse | null>(null);
    const [loading, setlLoading] = useState<boolean>(true);
    const [hasPermission, setHasPermission] = useState<boolean>(true);
    
    // Create token refresh manager instance (only once)
    const [refreshManager] = useState(() => createTokenRefreshManager());

    // Check MS Graph API status for permission
    const checkPermissionStatus = () => {
        // If user is successfully authenticated and has user data, assume permission is granted
        if (userData && accounts.length > 0) {
            setHasPermission(true);
            return true;
        }
        
        const msGraphStatus = localStorage.getItem('msGraphApiStatus');
        if (msGraphStatus) {
            try {
                const statusData = JSON.parse(msGraphStatus);
                if (statusData.error && statusData.status) {
                    setHasPermission(false);
                    return false;
                }
            } catch (error) {
                console.error('MS Graph api error: ', error);
                localStorage.removeItem('msGraphApiStatus');
            }
        }
        return true;
    };

  const requestProfileData = async () => {
        try {
            if (accounts.length) {
                // Silently acquires an access token which is then attached to a request for MS Graph data
                // acquireTokenSilent() will handle expired token automatically
                const graphTokenResponse = await instance.acquireTokenSilent({
                    ...graphTokenRequest,
                    account: accounts[0],
                });
                setAccount(graphTokenResponse.account);

                const backendApiTokenResponse = await instance.acquireTokenSilent({
                    ...backendApiTokenRequest,
                    account: accounts[0],
                });
                setAccessToken(backendApiTokenResponse.accessToken);

                // Fetch extra data from API
                const user = await fetchUser(graphTokenResponse.accessToken);
                setUserData(user);
                
                
                // Calculate token expiration time in seconds
                const expiresIn = backendApiTokenResponse.expiresOn
                    ? Math.floor((backendApiTokenResponse.expiresOn.getTime() - Date.now()) / 1000)
                    : 3600; // Default to 1 hour if expiresOn is not available
                
                // Define recursive refresh function
                const scheduleTokenRefresh = async (): Promise<{ token: string; expiresOn: Date | null }> => {
                    // Refresh callback function
                    const refreshedResponse = await instance.acquireTokenSilent({
                        ...backendApiTokenRequest,
                        account: accounts[0],
                    });
                    
                    // Update state with new token
                    setAccessToken(refreshedResponse.accessToken);
                    
                    // Calculate new token expiration and schedule next refresh
                    const newExpiresIn = refreshedResponse.expiresOn
                        ? Math.floor((refreshedResponse.expiresOn.getTime() - Date.now()) / 1000)
                        : 3600;
                    
                    // Recursively schedule next refresh
                    refreshManager.startAutoRefresh(newExpiresIn, scheduleTokenRefresh);
                    
                    // Return token info for logging
                    return {
                        token: refreshedResponse.accessToken,
                        expiresOn: refreshedResponse.expiresOn || null
                    };
                };
                
                // Start automatic token refresh
                refreshManager.startAutoRefresh(expiresIn, scheduleTokenRefresh);

                
            }
        } finally {
            setlLoading(false);
        }
    }

    useEffect(() => {
        requestProfileData();
        
        // Cleanup function: stop refresh when component unmounts
        return () => {
            refreshManager.stopAutoRefresh();
        };
    }, [accounts, instance]);

    // Check permission status after userData is loaded
    useEffect(() => {
        checkPermissionStatus();
    }, [userData, accounts]);
    /*--------------------------------------------------------------------------------------------------------*/

    if (loading) {
        return null;
    }

    return (
        <Router account={account} accessToken={accessToken} userData={userData} error={error} hasPermission={hasPermission}/>
    );
}

export default App;
